import React, { useEffect, useRef, useState } from "react";
import SubjectBox from "./SubjectBox";
import axios from "../../../../../axios";
import { SubjectIcon } from "../../../../../SubjectIcon";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Chip } from "@mui/material";

const SubjBoxProps = ({ filter }) => {
  const [variable, setVariable] = useState([]);
  const [isGettingData, setIsGettingData] = useState(true);
  const scrollContainerRef = useRef(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  const scrollRight = () => {
    scrollContainerRef.current?.scrollBy({ left: 400, behavior: "smooth" });
  };

  const scrollLeft = () => {
    scrollContainerRef.current?.scrollBy({ left: -400, behavior: "smooth" });
  };

  const checkOverflow = () => {
    const container = scrollContainerRef.current;
    if (container) {
      setIsOverflowing(container.scrollWidth > container.clientWidth);
    }
  };

  useEffect(() => {
    const handleResize = () => checkOverflow();
    // Delay checking to wait for DOM rendering
    const timer = setTimeout(() => checkOverflow(), 200);

    window.addEventListener("resize", handleResize);
    return () => {
      clearTimeout(timer);
      window.removeEventListener("resize", handleResize);
    };
  }, [variable]);

  useEffect(() => {
    let Teacher_id = localStorage.getItem("Teacher_id");
    let Teacher_Json = JSON.parse(Teacher_id);
    const timetableSessionId = localStorage.getItem("timeTableSessionId");
    const academicSessionId = localStorage.getItem("academicYearSessionId");
    const academic_Json = JSON.parse(academicSessionId);
    const timeTable_Json = JSON.parse(timetableSessionId);

    const helper = async () => {
      try {
        const response = await axios.get(
          `/api/v1/assessment/teacherSummary/get/teacherId/${Teacher_Json}?academicSessionId=${academic_Json}&timetableSessionId=${timeTable_Json}&standardId=${filter.standard_id}&sectionId=${filter.section_id}`,
        );
        response && setVariable(response.data.data);
      } catch (err) {
        console.error("Error fetching assessment summary:", err);
      } finally {
        setIsGettingData(false);
      }
    };

    if (Teacher_Json !== null) {
      helper();
    }
  }, [filter.standard_id, filter.section_id]);

  return (
    <div
      className="publish_summery_container gap-3 mb-2 mt-2 "
      style={{
        width: "100%",
        backgroundColor: "#f2f2f2",
        overflowX: "auto",
        overflowY: "hidden",
      }}
    >
      {/* Loading */}
      {isGettingData ? (
        <div className="text-center w-100 py-3">
          <div className="spinner-border text-warning" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : (
        <div
          ref={scrollContainerRef}
          className="publish_summery_container mb-4 gap-3 d-flex align-items-center "
          style={{
            overflowX: "auto",
            scrollBehavior: "smooth",
            alignItems: "center",
            position: "relative",
            minHeight: "150px",
          }}
        >
          {/* Left Sticky Button */}
          {isOverflowing && (
            <button
              type="button"
              className="btn btn-light d-flex align-items-center justify-content-center shadow"
              onClick={scrollLeft}
              style={{
                position: "sticky",
                left: 0,

                top: "50%",
                transform: "translateY(-50%)",
                borderRadius: "50%",
                backgroundColor: "#FDEFE3",
                width: "40px",
                height: "40px",
                border: "1px solid #4B4B4B",
              }}
            >
              <ChevronLeft color="#4B4B4B" size={24} />
            </button>
          )}

          {/* Subject Cards */}
          {!isGettingData && variable.length > 0 ? (
            variable.map((obj, index) => (
              <SubjectBox
                key={index}
                subname={obj?.subject?.name}
                sublogo={
                  SubjectIcon?.find((i) => i.subjectName === obj?.subject?.name)
                    ?.icon || "/subIcon/ic_png_science.png"
                }
                started={obj?.not_started}
                progress={obj?.on_review}
                complateed={obj?.completed}
              />
            ))
          ) : !isGettingData ? (
            <span className=" ms-3"> Assessments Not Found</span>
          ) : null}

          {/* Right Sticky Button */}
          {isOverflowing && (
            <button
              type="button"
              className="btn btn-light d-flex align-items-center justify-content-center shadow"
              onClick={scrollRight}
              style={{
                position: "sticky",
                right: 0,
                zIndex: 0,
                top: "50%",
                transform: "translateY(-50%)",
                borderRadius: "50%",
                backgroundColor: "#FDEFE3",
                width: "40px",
                height: "40px",
                border: "1px solid #4B4B4B",
              }}
            >
              <ChevronRight color="#4B4B4B" size={24} />
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default SubjBoxProps;
